export default __webpack_public_path__ + "static/media/rocket_anim_74.d42bac6d.png";